import gql from 'graphql-tag';

export const GET_SCORECARD_CONFIGURATION = gql`
  query GetScoreCardConfiguration {
    scoreCard {
      accountId
      financeProgramId
      structure
      createdDateTime
      modifiedDateTime
      prescreenCriteria {
        active
        accountId
        jsonCriteria
        prescreenCriteriaId
      }
    }
  }
`;
